import { useState } from "react";
import "./drawer.css";
import {
  CssBaseline,
  Typography,
  Link,
  Toolbar,
  Divider,
  IconButton,
  Box,
  AppBar,
  Drawer,
} from "@mui/material";
import { YouTube, Instagram } from "@mui/icons-material";
import MenuIcon from "@mui/icons-material/Menu";
import ButtonEnglish from "./Components/UI/English/Button English";
import logo from "./assetes/logo.png";

const drawerWidth = 200;
const appbarwidth = 1;

function ResponsiveDrawer(props) {
  const { window } = props;
  const [mobileOpen, setMobileOpen] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  const handleDrawerClose = () => {
    setIsClosing(true);
    setMobileOpen(false);
  };

  const handleDrawerTransitionEnd = () => {
    setIsClosing(false);
  };

  const handleDrawerToggle = () => {
    if (!isClosing) {
      setMobileOpen(!mobileOpen);
    }
  };

  const drawer = (
    <div>
      <Toolbar />
      <Box>
        <Typography
          variant="h5"
          sx={{
            color: "#49519A",
            paddingLeft: 2,
            paddingTop: 2,
            paddingBottom: 2,
          }}
        >
          منو
        </Typography>
      </Box>
      <Divider />
      <Link href="#" underline="none" color="white">
        <Typography
          sx={{
            fontSize: "1.2rem",
            color: "#49519A",
            paddingLeft: 2,
            paddingTop: 2,
          }}
        >
          صفحه نخست
        </Typography>
      </Link>
      <Link href="#about" underline="none" color="white">
        <Typography
          sx={{
            fontSize: "1.2rem",
            color: "#49519A",
            paddingLeft: 2,
            paddingTop: 2,
          }}
        >
          درباره ما
        </Typography>
      </Link>

      <Link href="#projects" underline="none" color="white">
        <Typography
          sx={{
            fontSize: "1.2rem",
            color: "#49519A",
            paddingLeft: 2,
            paddingTop: 2,
          }}
        >
          پروژه ها
        </Typography>
      </Link>
      <Link href="#contact" underline="none" color="white">
        <Typography
          sx={{
            fontSize: "1.2rem",
            color: "#49519A",
            paddingLeft: 2,
            paddingTop: 2,
            paddingBottom: 2,
          }}
        >
          ارتباط با ما
        </Typography>
      </Link>
      <Divider />
      <Typography
        variant="h5"
        sx={{
          color: "#49519A",
          paddingLeft: 2,
          paddingTop: 2,
          paddingBottom: 2,
        }}
      >
        لینک ها
      </Typography>
      <a
        href="https://digimakala.com/"
        target="_blank"
        style={{
          marginRight: "20px",
          fontSize: "1.1rem",
          textDecoration: "none",
          color: "#49519A",
          display: "block",
        }}
      >
        فروشگاه آنلاین
      </a>
      <div style={{ marginRight: "20px" }}>
        <IconButton>
          <a
            target="_blank"
            href="https://www.instagram.com/imaindco?igsh=aXdyM21uNTJ3YjEy"
          >
            <Instagram sx={{ color: "#49519A", margin: "2px" }} />
          </a>
        </IconButton>
        <IconButton>
          <a target="_blank" href="https://www.youtube.com/@IMAINDco">
            <YouTube
              sx={{ fontSize: "2rem", color: "#49519A", margin: "2px" }}
            />
          </a>
        </IconButton>
      </div>
    </div>
  );

  return (
    <Box className="drawer" sx={{ display: "flex" }}>
      <CssBaseline />

      <AppBar
        position="fixed"
        sx={{
          width: { sm: `calc(100% - ${appbarwidth}px)` },
          ml: { sm: `${drawerWidth}px` },
          mr: { sm: `${appbarwidth}px` },
        }}
      >
        <Toolbar sx={{ backgroundColor: "#F4F4F4" }}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2 }}
          >
            <MenuIcon sx={{ color: "#49519A" }} />
          </IconButton>
          <img
            src={logo}
            alt="IMA"
            style={{ width: "7rem", margin: "1rem" }}
          ></img>
          <Typography sx={{ color: "#49519A" }}> گروه صنعتی ایما</Typography>
        </Toolbar>
        <div>
          <ButtonEnglish />
        </div>
      </AppBar>
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders"
      >
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onTransitionEnd={handleDrawerTransitionEnd}
          onClose={handleDrawerClose}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { xs: "block", sm: "block" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: "none", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: { sm: `calc(100% - ${drawerWidth}px)` },
        }}
      >
        <Toolbar />
      </Box>
    </Box>
  );
}

export default ResponsiveDrawer;
